<template>
  <DeepLoaderAnimation :color="computedColor" />
</template>
<script lang="ts" setup>
import { DeepLoaderAnimation, useTplColors } from '@deepcloud/deep-ui-lib'

const props = defineProps({
  color: {
    type: String,
    default: undefined,
  },
})

const tplColors = useTplColors()

const computedColor = computed(
  () => props.color || tplColors.getTplColorByName('primary'),
)
</script>
